var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4 1.2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 0.9,
    fill: "#E4E4E4",
    cx: 61.2,
    cy: 61.2,
    r: 61.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.29 101.057H38.891V46.415c0-.816.662-1.477 1.478-1.477h40.445c.816 0 1.477.661 1.477 1.477v54.642z",
    stroke: "#444",
    strokeWidth: 1.62,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.59 85.834H48.816l2.795-7.93c.464-1.316 1.647-2.189 2.968-2.189h12.25c1.32 0 2.504.873 2.968 2.189l2.795 7.93zM75.284 92.81h.087c.042 0 .084.007.126.013v-5.36c0-.9-.686-1.629-1.532-1.629H47.441c-.846 0-1.531.73-1.531 1.629v5.347h29.374z",
    fill: "#DFDFDF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.477 58.195h-5.986a.748.748 0 0 1-.748-.748v-7.482c0-.414.335-.749.748-.749h5.986c.414 0 .749.335.749.749v7.482a.748.748 0 0 1-.749.748zM63.694 58.195h-5.986a.748.748 0 0 1-.748-.748v-7.482c0-.414.335-.749.748-.749h5.986c.414 0 .748.335.748.749v7.482a.748.748 0 0 1-.748.748zM77.911 58.195h-5.986a.748.748 0 0 1-.748-.748v-7.482c0-.414.334-.749.748-.749h5.986c.414 0 .748.335.748.749v7.482a.748.748 0 0 1-.748.748z",
    fill: "#F7F7F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.261 83.699 1.833-5.203c.232-.658.824-1.094 1.484-1.094h12.25c.66 0 1.252.436 1.484 1.094l1.833 5.203c.077.217-.074.449-.292.449h-18.3c-.217 0-.369-.232-.292-.45z",
    fill: "#FAFAFA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 80.775h-4.194a.546.546 0 0 1-.545-.546v-1.158c0-.3.244-.546.545-.546H62.8c.3 0 .545.244.545.546v1.158a.545.545 0 0 1-.545.546z",
    fill: "#BABABA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88 79.628h-.353a.352.352 0 0 1-.352-.351V77.38h1.057v1.897a.352.352 0 0 1-.353.351z",
    fill: "#A8A8A8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.371 97.124h-29.34a.925.925 0 0 1-.924-.925v-2.464c0-.511.414-.925.924-.925h29.34c.51 0 .924.414.924.925v2.464c0 .51-.414.925-.924.925z",
    fill: "#C1C1C1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.53 97.124v2.983c0 .526.4.954.896.954h2.573c.495 0 .897-.428.897-.954v-2.983h-4.367zM67.756 97.124v2.983c0 .526.401.954.897.954h2.573c.495 0 .896-.428.896-.954v-2.983h-4.366z",
    fill: "#989898",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59 92.069c-1.424 0-2.582-1.232-2.582-2.747s1.158-2.747 2.581-2.747c1.424 0 2.582 1.232 2.582 2.747s-1.158 2.747-2.582 2.747z",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59 91.238c-.994 0-1.802-.86-1.802-1.916 0-1.057.808-1.917 1.801-1.917.994 0 1.802.86 1.802 1.917 0 1.056-.808 1.916-1.802 1.916z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.817 92.069c-1.424 0-2.581-1.232-2.581-2.747s1.157-2.747 2.58-2.747c1.424 0 2.582 1.232 2.582 2.747s-1.158 2.747-2.581 2.747z",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.817 91.238c-.993 0-1.801-.86-1.801-1.916 0-1.057.808-1.917 1.8-1.917.994 0 1.802.86 1.802 1.917 0 1.056-.808 1.916-1.801 1.916z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.607 90.728H55.8a.644.644 0 0 1-.643-.644V88.56c0-.355.288-.643.643-.643h9.808c.355 0 .643.288.643.643v1.524a.644.644 0 0 1-.643.644z",
    fill: "#CBCBCB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.415 44.938H44.988v-7.873c0-.826.67-1.496 1.496-1.496h28.434c.826 0 1.497.67 1.497 1.496v7.873zM68.558 35.569H52.844v-5.735c0-.748.606-1.354 1.354-1.354h13.006c.747 0 1.353.606 1.353 1.354v5.735z",
    stroke: "#444",
    strokeWidth: 1.62,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.558 36.317H52.844a.749.749 0 0 1-.748-.748v-5.735c0-1.16.944-2.102 2.102-2.102h13.006c1.16 0 2.102.943 2.102 2.102v5.735a.748.748 0 0 1-.748.748zM53.593 34.82H67.81v-4.986a.607.607 0 0 0-.606-.606H54.198a.607.607 0 0 0-.605.606v4.986z",
    fill: "#C8C8C8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.415 45.686H44.988a.748.748 0 0 1-.748-.748v-7.873a2.247 2.247 0 0 1 2.244-2.245h28.434a2.247 2.247 0 0 1 2.245 2.245v7.873a.748.748 0 0 1-.748.748zM45.736 44.19h29.93v-7.125a.749.749 0 0 0-.748-.748H46.484a.749.749 0 0 0-.748.748v7.125z",
    fill: "#C8C8C8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.96 105.55H31.442a.671.671 0 0 1-.671-.671v-3.147c0-.37.3-.67.671-.67H89.96c.37 0 .67.3.67.67v3.147a.67.67 0 0 1-.67.671z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.96 106.299H31.442a1.42 1.42 0 0 1-1.42-1.42v-3.147c0-.782.637-1.419 1.42-1.419H89.96c.782 0 1.419.637 1.419 1.42v3.146a1.42 1.42 0 0 1-1.42 1.42zm-58.44-1.497h58.363v-2.993H31.52v2.993z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.477 58.944h-5.986a1.498 1.498 0 0 1-1.496-1.497v-7.482c0-.826.671-1.497 1.496-1.497h5.986c.825 0 1.497.67 1.497 1.497v7.482c0 .825-.672 1.497-1.497 1.497zm-5.986-8.98v7.483h5.987v-7.482H43.49zM63.694 58.944h-5.986a1.498 1.498 0 0 1-1.496-1.497v-7.482c0-.826.671-1.497 1.496-1.497h5.986c.825 0 1.497.67 1.497 1.497v7.482c0 .825-.672 1.497-1.497 1.497zm-5.986-8.98v7.483h5.987v-7.482h-5.987zM77.911 58.944h-5.986a1.498 1.498 0 0 1-1.497-1.497v-7.482c0-.826.672-1.497 1.497-1.497h5.986c.825 0 1.497.67 1.497 1.497v7.482c0 .825-.672 1.497-1.497 1.497zm-5.986-8.98v7.483h5.987v-7.482h-5.987z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.29 101.805H38.891a.748.748 0 0 1-.748-.748V46.415c0-1.227.998-2.225 2.226-2.225h40.444c1.227 0 2.226.998 2.226 2.225v54.642a.748.748 0 0 1-.749.748zm-42.65-1.496h41.902V46.415a.73.73 0 0 0-.729-.729H40.37a.73.73 0 0 0-.73.729v53.894z",
    fill: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.01 28.48V17.069a1.31 1.31 0 1 0-2.618 0v11.41h2.619z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.01 29.228h-2.618a.749.749 0 0 1-.749-.748V17.069a2.06 2.06 0 0 1 2.058-2.058 2.06 2.06 0 0 1 2.058 2.058v11.41a.749.749 0 0 1-.748.75zm-1.87-1.496h1.122V17.069a.562.562 0 0 0-1.122 0v10.663z",
    fill: "#C8C8C8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#909090"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.315 76.266c.699.7.197 1.896-.786 1.896-.981 0-1.485-1.196-.785-1.896a1.11 1.11 0 0 1 1.57 0zM75.251 75.167a.592.592 0 0 0 0-.837 3.847 3.847 0 0 0-5.444 0 .592.592 0 0 0 .838.837 2.663 2.663 0 0 1 3.769 0 .592.592 0 0 0 .837 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.447 72.969a5.77 5.77 0 0 1 8.165 0 .593.593 0 0 0 .838-.838 6.955 6.955 0 0 0-9.841 0 .592.592 0 0 0 .838.838z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.de80d80c2443fd8aa557c71e0950e0fe.svg";
export { ForwardRef as ReactComponent };